module.exports = "/images/vendor/jquery-ui-dist/ui-icons_777620_256x240.png?c61734979ffc066b66a29e86229252ce";